// log some application information
import pkg from "../package.json";
import {useState} from "react";

console.log(`${pkg.name} ${pkg.version}`);

/**
 * The app version, imprint and contact information.
 */
export function Footer() {
    const [showImprint, setShowImprint] = useState(false);

    return (
        <div
            className="footer"
            aria-label="footer values"
            style={{flex: "0 0 auto", display: "flex",
                alignItems: showImprint ? "flex-start" : "center", justifyContent: "space-between", position: "relative",
                overflowY: "auto"}}
        >
            {!showImprint ? (
                <>
                    <div style={{flex: "1", display: "flex", justifyContent: "flex-start", gap: "10px"}}>
                        <span>{pkg.name} demo</span>
                        <span>version {pkg.version}</span>
                    </div>
                    <div style={{flex: "1", display: "flex", justifyContent: "flex-end", gap: "10px"}}>
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowImprint(true);
                            }}
                            style={{textDecoration: "underline", cursor: "pointer"}}
                        >
                            Impressum
                        </a>
                    </div>
                </>
            ) : (
                <>
                    <div style={{flex: "1", display: "flex", alignItems: "flex-start",
                        justifyContent: "flex-start",
                        flexDirection: "column", gap: "1px"}}>
                        <span>{pkg.name}</span>
                        <span>by Florian Nowotny</span>
                    </div>
                    <div style={{flex: "1", display: "flex",
                        flexDirection: "column", gap: "1px", textAlign: "right"}}>
                        <span>Am Wäldchen 4</span>
                        <span>D-65929 Frankfurt am Main</span>
                    </div>
                    <div style={{flex: "1", display: "flex", justifyContent: "flex-end",
                        flexDirection: "column", gap: "1px", textAlign: "right", paddingRight: "40px"}}>
                        <a href="mailto:3daudio@gmail.com">3daudio@gmail.com</a>
                        <span>Tel: +49 69 405 90386</span>
                    </div>
                    <button
                        onClick={() => setShowImprint(false)}
                        aria-label="close imprint"
                        style={{
                            position: "absolute",
                            right: "8px",
                            background: "transparent",
                            color: "white",
                            fontSize: "16px",
                            cursor: "pointer",
                            padding: "4px",
                            border: "none"
                        }}
                    >
                        ✕
                    </button>
                </>
            )}
        </div>
    );
}